// extracted by mini-css-extract-plugin
export default {"ai-powered-risk-intelligence-brief":"AIPoweredRiskIntelligenceBrief_ai-powered-risk-intelligence-brief__VnA2L"};